<template>
  <layout-side-menu-content>
    <settings-caption>
      パスワードの変更
    </settings-caption>

    <form-component />
    <button-update />
  </layout-side-menu-content>
</template>

<script>
import LayoutSideMenuContent from '@/lib/Layout/SideMenuContent'
import SettingsCaption from '@/components/Settings/Caption'
import FormComponent from './FormComponent/index'
import ButtonUpdate from './ButtonUpdate'

export default {
  components: {
    LayoutSideMenuContent,
    SettingsCaption,
    FormComponent,
    ButtonUpdate
  }
}
</script>
